import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('[Supabase] Variabili VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY non configurate — sync disabilitato.');
}

export const supabase = createClient(supabaseUrl ?? '', supabaseAnonKey ?? '');
